<ng-container *ngIf="guilds && guilds.length > 0">
  <!-- Help Text Banner -->
  <div class="help-banner">
    <div class="help-banner-content">
      <div class="help-banner-text" [innerHTML]="helpText"></div>
    </div>
  </div>

  <!-- Guild Cards Grid -->
  <div class="guild-cards-grid">
    <div *ngFor="let guild of guilds" class="guild-card">
      <div class="guild-card-image-wrapper">
        <img 
          *ngIf="guild.id && guild.icon; else defaultIcon" 
          class="guild-card-image" 
          [alt]="guild.name + ' icon'"
          [src]="'https://cdn.discordapp.com/icons/' + guild.id + '/' + guild.icon + '.png?size=256'"
          loading="lazy">
        <ng-template #defaultIcon>
          <img 
            class="guild-card-image" 
            [alt]="guild.name + ' icon'"
            [src]="'https://cdn.discordapp.com/icons/' + raidOrganizerGuild.id + '/' + raidOrganizerGuild.icon + '.png?size=256'"
            loading="lazy">
        </ng-template>
      </div>
      <div class="guild-card-body">
        <h5 class="guild-card-title">{{ guild.name }}</h5>
        <button 
          *ngIf="buttonText && !guild.joined" 
          type="button" 
          class="guild-card-button"
          (click)="selectGuild(guild.id)">
          {{ buttonText }}
        </button>
        <button 
          *ngIf="guild.joined" 
          type="button" 
          class="guild-card-button"
          routerLink="/guilds/{{guild.id}}" 
          (click)="setGuild(guild)">
          {{ buttonText }}
        </button>
      </div>
    </div>
  </div>
</ng-container>
